import { controlador, urlPhp8 } from "constants/urls";

const base = `${urlPhp8}${controlador}api/v1/auto`;

export const urlMarcas = `${base}/marcas`;

export const urlAnios = `${base}/anios`;

export const urlModelos = `${base}/modelos`;

export const urlRecuperarCotizacionPaginaUno = `${base}/recuperar-cotizacion-pantalla-uno`;

export const urlGuardarDatosPaginaUno = `${base}/guardar-datos-pantalla-uno`;

export const urlPlanes = `${base}/planes`;

export const urlRecuperarCotizacionPaginaDos = `${base}/recuperar-cotizacion-pantalla-dos`;

export const urlGuardarSeleccionarPlan = `${base}/seleccionar-plan`;

export const urlRecuperarCotizacionPaginaTres = `${base}/recuperar-cotizacion-pantalla-uno`;

export const urlTarifar = `${base}/tarifar`;

export const urlCrearPoliza = `${base}/crear-poliza`;

export const urlRecuperarDatosRiesgo = `${base}/recuperar-datos-riesgo`;

export const urlGuardarDatosRiesgo = `${base}/guardar-datos-riesgo`;
